import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { trpcQueryUtils } from '@web/lib/trpc';

import { DashboardLayout } from './-components/layout';

import { router } from '@web/lib/react-router';

let contactInfoSidebarContactId: string | null = null;

const setContactInfoSidebarContactId = (contactId: string | null) => {
  contactInfoSidebarContactId = contactId;
  void router.invalidate();
};

let activeContractId: string | null = null;

const setActiveContractId = (contractId: string | null) => {
  console.log('-->  setActiveContractId ~ contractId:', contractId);

  activeContractId = contractId;

  if (contractId === null) void trpcQueryUtils.contracts.listAll.refetch();

  void router.invalidate();
};

let activePaymentContractId: string | null = null;

const setActivePaymentContractId = (contractId: string | null) => {
  activePaymentContractId = contractId;
  void router.invalidate();
};

let activeCommentId: string | null = null;

const setActiveCommentId = (commentId: string | null) => {
  activeCommentId = commentId;
  void router.invalidate();
};

let editContactDialogContactId: string | null = null;

const setEditContactDialogContactId = (contactId: string | null) => {
  editContactDialogContactId = contactId;
  void router.invalidate();
};

let createContactDialogOpen = false;

const setCreateContactDialogOpen = (open: boolean) => {
  createContactDialogOpen = open;
  void router.invalidate();
};

let navbarOpen = false;

const toggleNavbarOpen = () => {
  navbarOpen = !navbarOpen;
  void router.invalidate();
};

const setNavbarOpen = (open: boolean) => {
  navbarOpen = open;
  void router.invalidate();
};

export const Route = createFileRoute('/dashboard')({
  component: Component,

  beforeLoad: ({
    context: {
      auth: { user },
    },
  }) => {
    if (!user)
      throw redirect({
        to: '/auth/sign-in',
        search: { returnTo: `${location.pathname}${location.search}` },
      });

    return {
      loggedInUser: user,
      contactInfoSidebarContactId,
      setContactInfoSidebarContactId,
      activeContractId,
      setActiveContractId,
      activePaymentContractId,
      setActivePaymentContractId,
      activeCommentId,
      setActiveCommentId,
      editContactDialogContactId,
      setEditContactDialogContactId,
      createContactDialogOpen,
      setCreateContactDialogOpen,
      navbarOpen,
      toggleNavbarOpen,
      setNavbarOpen,
    };
  },
});

function Component() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
